import axios from 'axios';
import store from '../store';

export class ScreenRecorderService {
  static stream: any;
  static recorder: any;
  static videoChunks: any[] = [];

  static async startRecording() {
    // @ts-ignore
    ScreenRecorderService.stream = await navigator.mediaDevices.getDisplayMedia({
      video: { mediaSource: "screen" }
    });
    // @ts-ignore
    ScreenRecorderService.recorder = new MediaRecorder(ScreenRecorderService.stream);
    ScreenRecorderService.recorder.ondataavailable = (e: any) => ScreenRecorderService.videoChunks.push(e.data);
    ScreenRecorderService.recorder.start();
  }

  static stopRecording() {
    ScreenRecorderService.recorder.onstop = () => {
      const completeBlob = new Blob(ScreenRecorderService.videoChunks, { type: ScreenRecorderService.videoChunks[0].type });
      ScreenRecorderService.uploadVideo(completeBlob)
      const videoSrc = URL.createObjectURL(completeBlob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      // @ts-ignore
      a.style = 'display: none';
      a.href = videoSrc;
      a.download = 'issue';
      a.click();
      window.URL.revokeObjectURL(videoSrc);
    };
    ScreenRecorderService.recorder.stop();
    ScreenRecorderService.stream.getVideoTracks()[0].stop();
    ScreenRecorderService.videoChunks = [];
  }

  static async uploadVideo(videoBlob: any) {
    try {
      const formData = new FormData();
      formData.append('video', videoBlob);
      await axios.post(
        '/api/v1/upload-issue',
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' }}
      );
    } catch (error) {
      store.commit('setSnackbar', { serverMessage: error.response.data.message || error.message, show: true, color: 'error' });        
    }
  }

}